module.exports = __webpack_public_path__ + "static/media/ic_add_student.c6c25e76.svg";